export enum StatusRevisao {
  EM_ABERTO = 'EM_ABERTO',
  REALIZADA = 'REALIZADA'
}
